import React, {useEffect} from "react";
import {Box} from "@mui/material";
import AddScheduleForm from "./AddScheduleForm";
import {dataSourceHandleActions, organizationActions, payoutsActions, pricingActions} from "../../../../../_actions";
import {Loading} from "../../../../common";
import {useDispatch, useSelector} from "react-redux";
import {queryStringToObject} from "../../../../../_helpers";

export default function AdminAddSchedule() {
    const dispatch = useDispatch()
    const search = window.location.search.substring(1);
    const urlParams =  queryStringToObject(search);
    const organizationId = urlParams.organization

    const dataSourceHandles = useSelector((state) => state.dataSourceHandles.dataSourceHandles)
    const payoutRates = useSelector((state) => state.payout.all_payouts)
    const pricingRates = useSelector((state) => state.pricing.all_pricing)
    const organization = useSelector(state => state.organizations.organization);
    const dataSourceHandlesLoading = useSelector((state) => state.dataSourceHandles.loading)
    const payoutRatesLoading = useSelector((state) => state.payout.loading)
    const pricingRatesLoading = useSelector((state) => state.pricing.loading)

    const dataSourceOptions = dataSourceHandles.length > 0 ? dataSourceHandles.map(handle => {
        return {name: handle.name, id: handle.id}
    }) : []
    const payoutRatesOptions = payoutRates?.map(rate => {
        return {name: `${rate.label} - ${rate.currency.code} ${rate.amount}` , id: rate.id}
    })
    const pricingRatesOptions = pricingRates?.map(rate => {
        return {name: `${rate.label} - ${rate.currency.code} ${rate.amount}` , id: rate.id}
    })

    useEffect(() => {
        dispatch(payoutsActions.getAll())
        dispatch(pricingActions.getAll())
        if(organizationId){
            dispatch(dataSourceHandleActions.getAll({organization: organizationId}))
            dispatch(organizationActions.getOrganization(organizationId))
        }
    },[organizationId, dispatch])

    if (dataSourceHandlesLoading || payoutRatesLoading || pricingRatesLoading) return <Loading/>

    return(
        <Box sx={styles.root}>
            <Box sx={styles.container}>
                <Box component={"h1"} sx={styles.headingText}>Add Schedule</Box>
                <AddScheduleForm
                    payoutRates={payoutRatesOptions}
                    pricingRates={pricingRatesOptions}
                    dataSourceOptions={dataSourceOptions}
                    orgId={organizationId}
                    organization={organization}
                />
            </Box>
        </Box>
    )
}

const styles = {
    root: {
        fontFamily: 'LarsseitRegular',
        letterSpacing: '-0.02em',
        color: '#0C2728',
        backgroundColor: '#EFEAE7',
        pt: 13,
        pb: 10,
        minHeight: '100vh',
    },
    container: {
        px: { xs: 2, sm: 6 },
        maxWidth: '1440px',
        position: 'relative',
    },
    headingText: {
        mb: 0,
        fontFamily: 'LarsseitMedium',
        fontSize: 24,
        lineHeight: 1.2,
        letterSpacing: '-0.02em',
        color: '#0C2728'
    }
}